declare global {
    interface Window {
        analytics: {
            identify: (id: string | number, traits: any, extras: any) => void;
            page: () => void;
            track: (event: string, properties?: any) => void;
            ready: (fn: () => void) => void;
        };
    }
}

/**
 * Returns an event handler designed for an anchor element. When the link is clicked it will
 * track an event with Segment, then redirect the user to the target.
 */
export const trackLink = (event: string) => () => {
    if (window.analytics) {
        window.analytics.track(event);
    }
};
